import actions from './actions'
import getters from './getters'
import mutations from './mutations'

export default {
  namespaced: true,
  state: {
    taskCount: null,
    taskSettingsData: null,
    taskData: null
  },
  actions,
  getters,
  mutations
}
